const ANIMAL_COLOR_ACHIEVEMENTS = [
  {
    color: 'Base',
    petAchievement: 'backToBasics',
    petNotificationType: 'ACHIEVEMENT_PET_COLOR',
    mountAchievement: 'allYourBase',
    mountNotificationType: 'ACHIEVEMENT_MOUNT_COLOR',
  },
  {
    color: 'Desert',
    petAchievement: 'dustDevil',
    petNotificationType: 'ACHIEVEMENT_PET_COLOR',
    mountAchievement: 'aridAuthority',
    mountNotificationType: 'ACHIEVEMENT_MOUNT_COLOR',
  },
  {
    color: 'Zombie',
    petAchievement: 'monsterMagus',
    petNotificationType: 'ACHIEVEMENT_PET_COLOR',
    mountAchievement: 'undeadUndertaker',
    mountNotificationType: 'ACHIEVEMENT_MOUNT_COLOR',
  },
  {
    color: 'White',
    petAchievement: 'primedForPainting',
    petNotificationType: 'ACHIEVEMENT_PET_COLOR',
    mountAchievement: 'pearlyPro',
    mountNotificationType: 'ACHIEVEMENT_MOUNT_COLOR',
  },
  {
    color: 'CottonCandyPink',
    petAchievement: 'tickledPink',
    petNotificationType: 'ACHIEVEMENT_PET_COLOR',
    mountAchievement: 'rosyOutlook',
    mountNotificationType: 'ACHIEVEMENT_MOUNT_COLOR',
  },
  {
    color: 'Golden',
    petAchievement: 'goodAsGold',
    petNotificationType: 'ACHIEVEMENT_PET_COLOR',
    mountAchievement: 'allThatGlitters',
    mountNotificationType: 'ACHIEVEMENT_MOUNT_COLOR',
  },
  {
    color: 'Skeleton',
    petAchievement: 'boneCollector',
    petNotificationType: 'ACHIEVEMENT_PET_COLOR',
    mountAchievement: 'skeletonCrew',
    mountNotificationType: 'ACHIEVEMENT_MOUNT_COLOR',
  },
  {
    color: 'Red',
    petAchievement: 'seeingRed',
    petNotificationType: 'ACHIEVEMENT_PET_COLOR',
    mountAchievement: 'redLetterDay',
    mountNotificationType: 'ACHIEVEMENT_MOUNT_COLOR',
  },
  {
    color: 'CottonCandyBlue',
    petAchievement: 'violetsAreBlue',
    petNotificationType: 'ACHIEVEMENT_PET_COLOR',
    mountAchievement: 'wildBlueYonder',
    mountNotificationType: 'ACHIEVEMENT_MOUNT_COLOR',
  },
  {
    color: 'Shade',
    petAchievement: 'shadyCustomer',
    petNotificationType: 'ACHIEVEMENT_PET_COLOR',
    mountAchievement: 'shadeOfItAll',
    mountNotificationType: 'ACHIEVEMENT_MOUNT_COLOR',
  },
];

export default ANIMAL_COLOR_ACHIEVEMENTS;
